var _circle, _circle2, _line, _path, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 48.73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    cx: 59.99,
    cy: 38.8,
    r: 7.43
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    cx: 24.25,
    cy: 38.8,
    r: 7.43
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    x1: 31.68,
    x2: 53.72,
    y1: 38.8,
    y2: 38.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    d: "m69.63 38.8 7.06 0.08c3.21 0 5.81-2.6 5.81-5.81v-7.94c0-2.62-1.76-4.92-4.29-5.61l-14.07-2.85c-1.38-0.37-2.57-1.24-3.35-2.43l-6.26-9.11c-1.07-1.64-2.9-2.63-4.86-2.63h-17.01c-6.12 0-11.83 3.07-15.21 8.17l-2.54 3.83c-0.67 1.02-1.65 1.79-2.78 2.23l-5.88 2.23c-2.26 0.86-3.75 3.02-3.75 5.43v8.68c0 3.21 2.6 5.81 5.81 5.81h8.51"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    transform: "translate(-7.5,-25.64)",
    points: "46.6 28.13 46.6 42.31 71.64 42.31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.cf9d8bb2.svg";
export { ForwardRef as ReactComponent };